// Custom Turbo Stream action to remove a CSS class from an element
import { StreamActions } from "@hotwired/turbo"

StreamActions.remove_class = function() {
  const targetId = this.getAttribute("target")
  const className = this.getAttribute("class-name")
  const element = document.getElementById(targetId)

  if (element && className) {
    element.classList.remove(className)
  }
}
